var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { getDetailAddress } from "./detail";
/** <b>Composant en mode consultation/detail d'un champ de type address</b>*/
export default function AddressFieldDetailEN(_a) {
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata, fieldDef = _a.fieldDef;
    var group = fieldMetadata.group;
    var value = useMemo(function () {
        if (!record) {
            return;
        }
        return getDetailAddress(group, record, fieldDef);
    }, [fieldName, record]);
    return (_jsx("div", __assign({ className: "dark:text-[rgb(var(--color-gray-400))]" }, { children: _jsxs("div", { children: [_jsx("div", __assign({ className: "" }, { children: value === null || value === void 0 ? void 0 : value.street })), _jsxs("div", { children: [value === null || value === void 0 ? void 0 : value.city, " ", value === null || value === void 0 ? void 0 : value.postalcode, " ", value === null || value === void 0 ? void 0 : value.state] }), _jsx("div", { children: value === null || value === void 0 ? void 0 : value.country })] }) })));
}
